import * as React from 'react';
import Router from './Router';

interface IProps {
  path: string | string[];
  children?: React.ReactElement<any>;
}

const Route: React.SFC<IProps> = (props: IProps) => {
  const { path, children } = props;
  if (path === '*' && !Router.shared.didFoundRoute) {
    return children || null;
  } else if (validatePath(path)) {
    Router.shared.didFoundRoute = true;
    return children || null;
  }
  return null;
};

function validatePath(path: string | string[]): boolean {
  const cpath = location.pathname;
  if (path instanceof Array) {
    for (const p of path) {
      if (p === cpath || p + '/' === cpath) {
        return true;
      }
    }
    return false;
  } else {
    return path === cpath || path + '/' === cpath;
  }
}

export default Route;



// WEBPACK FOOTER //
// ./src/router/Route.tsx